<template>
  <v-card elevation="0">
    <ItemPicturesCarousel :item="item"/>
    <v-card-text class="py-5 px-4 px-md-8" ref="content">
      <div class="d-flex align-center justify-space-between mb-6 pa-4" style="position: absolute; top: 0; right: 0;">
        <v-btn @click="$emit('close')" color="white" small icon style="background: tomato">
          <v-icon size="18">mdi-close</v-icon>
        </v-btn>
      </div>

      <div class="d-flex flex-column align-start fill-width mt-4">
        <div>{{ item.name }}</div>
        <div class="d-flex align-center justify-space-between fill-width">
          <div class="d-flex align-center mr-3">
            <v-rating :value="itemRating" background-color="orange lighten-3" color="orange" dense readonly size="20"/>
            <span class="text-small ml-2" v-if="item.total_ratings">({{ item.total_ratings }} review(s))</span>
          </div>
          <v-chip color="red" dark x-small>Credit</v-chip>
        </div>
      </div>

      <template v-if="item.monthly_amount < 1000000 && item.monthly_amount > 2000">
        <v-divider class="my-4"></v-divider>

        <div class="d-flex align-center justify-space-between mt-3">
          <div>
            <div class="title font-weight-bold text--black">
              {{ item.monthly_amount | currency }} / mo
            </div>
            <div class="text-body-1 mt-1">
              {{ item.no_of_months }} installment(s)
            </div>
          </div>
          <v-btn @click="addLike()" small icon>
            <v-icon color="red" v-if="liked">mdi-heart</v-icon>
            <v-icon v-else>mdi-heart-outline</v-icon>
          </v-btn>
        </div>
      </template>

      <v-divider class="my-4"></v-divider>

      <template v-if="sizes.length">
        <div class="d-inline-flex align-center">
          <v-radio-group
            class="ma-0" hide-details label="Size" row v-if="sizes && sizes.length"
            v-model="variations.size"
          >
            <v-radio :key="size" :label="size" :value="size" v-for="size in sizes"></v-radio>
          </v-radio-group>
        </div>
        <v-divider class="my-4"></v-divider>
      </template>

      <template v-if="item.monthly_amount < 1000000 && item.monthly_amount > 2000">
        <div class="d-flex mt-6">
          <v-text-field :value="quantity" dense hide-details outlined readonly style="max-width: 150px">
            <v-icon @click="decrementQuantity()" color="red" slot="prepend">mdi-minus</v-icon>
            <v-icon @click="incrementQuantity()" color="green" slot="append-outer">mdi-plus</v-icon>
          </v-text-field>
          <v-btn @click="addToCart()" class="flex-grow-1 ml-3" color="primary" elevation="0">
            <v-icon class="mr-2">mdi-cart-plus</v-icon>
            Add to cart
          </v-btn>
        </div>
      </template>
      <div v-else class="border-top mt-2 pt-4 fill-width mt-auto">
        <div class="d-flex align-center fill-width">
          <v-text-field
            :value="quantity" dense hide-details outlined readonly style="max-width: 120px" height="20px"
          >
            <v-icon @click="decrementQuantity()" color="red" slot="prepend">mdi-minus</v-icon>
            <v-icon @click="incrementQuantity()" color="green" slot="append-outer">mdi-plus</v-icon>
          </v-text-field>
          <v-btn @click="requestPrice()" class="flex-grow-1 ml-3" color="primary" elevation="0" outlined>
            <v-icon class="mr-2" size="20">mdi-help-circle</v-icon>
            Request price
          </v-btn>
        </div>
      </div>

      <v-snackbar :color="toast.color || ''" absolute bottom v-model="toast.visible">
        {{ toast.message }}
      </v-snackbar>

      <v-container class="mt-4">
        <v-tabs v-model="tab">
          <v-tab class="pa-0 mr-5">Description</v-tab>
          <v-tab class="pa-0 mr-5">Reviews ({{ item.total_ratings }})</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item class="py-6">
            <v-card class="px-8 py-6 mb-5" outlined>
              <v-subheader class="px-0 text--secondary" style="height: initial" v-if="!item.description">
                No description
              </v-subheader>
              <div class="text-title black--text text--lighten-2 pre-wrap" v-html="item.description"></div>
            </v-card>
          </v-tab-item>
          <v-tab-item class="py-6" v-if="$store.getters['merchant/theme'].show_product_comments">
            <Reviews :embedded="true" :itemId="item.id" @close="closeReview($event)" v-if="item.id"/>
          </v-tab-item>
        </v-tabs-items>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import item from "../../mixins/item";
import ItemPicturesCarousel from "@/components/item/ItemPicturesCarousel.vue";
import Reviews from "@/components/Reviews.vue";

export default {
  name: 'QuickAddToCart',
  components: { Reviews, ItemPicturesCarousel },
  mixins: [item],
  data: () => ({ tab: 0 }),
  methods: {
    requestPrice() {
      this.$store.commit('cart/addItem', {
        ...this.item,
        monthly_amount: 0,
        price: 0,
        credit_price: 0,
        unit: this.quantity
      });
      this.$bus.$emit('cart');
    }
  }
}
</script>
